import React, { Component } from "react";
import Card from "../../shared/Card";

class CallerInfo extends Component {
    constructor(props) {
        super(props);
        this.state = {
          isFetching: false,
        };
      }

      formatZipCode(zipcode) {
        return zipcode.slice(0, 5);
      }
            
    render() {
        const CallerInfo = (
            <Card
              cardType="default"
              cardHeader="Requestor"
              headerColor="#046B99"
              headerTextColor="white"
              cardBody={
                <div className="Caller-card">
                <div className="banner-title pl-0">{`${this.props.Call_Bus_Name}`}</div>
                <div>
                  {`${this.props.Call_Name}`}
                </div>
                <div>{`${this.props.Call_Str1}`}</div>
                <div>
                  {`${this.props.Call_City}`}, 
                  {" "}{`${this.props.Call_ST}`} {" "}
                  {`${this.formatZipCode(this.props.Call_ZIP)}`}
                </div>            

              </div>
              }
              cardColor="white"
            />
          );

          return <div>{CallerInfo}</div>;
    }
}
export default CallerInfo;